import { render, staticRenderFns } from "./WsLiveStateSwitch.vue?vue&type=template&id=6452e0a1&"
import script from "./WsLiveStateSwitch.vue?vue&type=script&lang=js&"
export * from "./WsLiveStateSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports